---
date: 2022-01-06
title: Remote API
---

For developers, the remote command API allows you to interact with indoorequal.org website to display a specific building, a level or open a preview. [Learn more on the API](https://github.com/indoorequal/indoorequal.org#remote-command-api).
